export const convertirABase64 = (texto: string): string => {
    return btoa(texto);
  }

  export const traducirDeBase64 = (texto: string): string => {
    return atob(texto);
  }
  